import createCache from '@emotion/cache';

// Create a cache that completely disables style injection for CSP compliance
const cache = createCache({
  key: 'css',
  // Use a nonce if your CSP requires it
  // nonce: 'your-nonce-here',
});

// Completely override the cache to prevent any style injection
const disabledCache = {
  ...cache,
  inserted: {},
  registered: {},
  insert: () => {
    // Completely prevent style injection
    return;
  },
  insertStyleTag: () => {
    // Prevent style tag insertion
    return;
  },
  hydrate: () => {
    // Prevent hydration
    return;
  },
  flush: () => {
    // Prevent flushing
    return [];
  }
} as any;

export const emotionCache = disabledCache;
export default emotionCache;
